import { v4 as uuidv4 } from 'uuid';
const USER_INFO = "SHAN_HE_USERINFO";
const TOKEN = "SHAN_HE_TOKEN";
/**
 * 获取用户信息
 *
 * 该函数尝试从localStorage中获取用户信息如果找到相关信息，则解析并返回这些信息；
 * 否则，返回null这在需要用户信息时特别有用，比如个性化设置或权限控制等
 *
 * @returns {Object|null} 返回解析后的用户信息对象，如果没有找到信息则返回null
 */
export function getUserInfo() {
  // 从localStorage中获取用户信息的字符串
  const userInfo = localStorage.getItem(USER_INFO);

  // 如果用户信息存在，则解析并返回该信息
  if (userInfo) {
    return JSON.parse(userInfo);
  }

  // 如果没有找到用户信息，返回null
  return null;
}

/**
 * 设置用户信息
 *
 * 该函数将用户信息对象存储在localStorage中，以便在需要时检索
 *
 * @param {Object} userInfo - 要存储的用户信息对象
 */
export function setUserInfo(userInfo) {
  if (userInfo) {
    // 将用户信息对象转换为JSON字符串，并存储在localStorage中
    localStorage.setItem(USER_INFO, JSON.stringify(userInfo));
  }
}

/**
 * 设置会员和云币信息
 *
 * 该函数将会员和云币信息对象存储在localStorage中，以便在需要时检索
 *
 * @param {Object} memberAndCloudCoinInfo - 要存储的会员和云币信息对象
 */
export function setMemberAndCloudCoinInfo(memberAndCloudCoinInfo) {
  let userInfo = getUserInfo();
  userInfo.memberType = memberAndCloudCoinInfo.memberInfo.memberType;
  userInfo.memberName = memberAndCloudCoinInfo.memberInfo.memberName;
  userInfo.cloudCoinBalance = memberAndCloudCoinInfo.myCloudCoinInfo.cloudCoinBalance;
  userInfo.expirationTime = memberAndCloudCoinInfo.myMemberInfo.formDate;
  setUserInfo(userInfo);
}


/**
 * 清除用户信息
 *
 * 该函数从localStorage中移除用户信息，通常用于注销或退出登录时
 */
export function clearUserInfo() {
  // 从localStorage中移除用户信息
  localStorage.removeItem(USER_INFO);
}

/**
 * 获取token
 *
 * 该函数从localStorage中获取token，通常用于需要验证用户身份的场合
 *
 * @returns {string|null} 返回获取到的token，如果没有找到则返回null
 */
export function getToken() {
  const token = localStorage.getItem(TOKEN);
  if (token) {
    return JSON.parse(token);
  }
  return null;
}

/**
 * 设置token
 *
 * 该函数将token存储在localStorage中，通常用于登录成功后设置token
 *
 * @param {string} token - 要存储的token字符串
 */
export function setToken(token) {
  if (token) {
    localStorage.setItem(TOKEN, JSON.stringify(token));
  }
}

/**
 * 清除token
 *
 * 该函数从localStorage中移除token，通常用于注销或退出登录时
 */
export function clearToken() {
  localStorage.removeItem(TOKEN);
}

/**
 * 获取用户uid
 *
 * 该函数从localStorage中获取token，并返回token中的uid
 *
 * @returns {string|null} 返回获取到的uid，如果没有找到则返回null
 */
export function getUserUid() {
  return getToken()?.tokenValue || null;
}

/**
 * 获取用户名
 *
 * 该函数从localStorage中获取用户信息，并返回用户信息中的username
 *
 * @returns {string|null} 返回获取到的username，如果没有找到则返回null
 */
export function getUsername() {
  return getUserInfo()?.username || null;
}

/**
 * 获取用户UUID
 *
 * 该函数从localStorage中获取用户信息，并返回用户信息中的username
 *
 * @returns {string|null} 返回获取到的username，如果没有找到则返回null
 */
export function getUserUUID() {
  return getUsername() == null ? uuidv4() : getUsername() + '_' + uuidv4();
}

/**
 * 检查用户是否已登录
 * 
 * @returns {Promise<boolean>} 返回Promise，解析为布尔值表示用户是否已登录
 */
export function checkLoginStatus() {
  const token = getToken();
  return token !== null;
}